import { render, staticRenderFns } from "./StepLegals.vue?vue&type=template&id=4c187b8c&"
import script from "./StepLegals.vue?vue&type=script&lang=js&"
export * from "./StepLegals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports